import React, { useCallback, useContext, useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"
import { AddressNS } from "@hg/hg-web-sdk/dist/constants/type"
import Scroll from "@hg/scroll"

import Toast from "@/topic/rogue_4/components/Toast"
import { GlobalContext } from "@/topic/rogue_4/context"
import { i18n } from "@/utils/i18n"
import { sdkReady } from "@/utils/sdk"
import GAME_GIFT_DICT from "../../../data/gift"
import { fill } from "../../../service"
import { useGameStore } from "../../../store"
import { SFX } from "../../../utils/sound"
import { getTransitionClassnames } from "../../../utils/transition"
import Button from "../../Button"
import ModalTitle from "../common/modalTitle"
import { useGameModalStore } from "../store"
import { trim } from "lodash"
import emitter from "../../../../../components/Bus/"
import styles from "./index.module.less"

const AddressModal: StyledComponent = ({ className, style }) => {
    const [active, setActive] = useState(false)
    useEffect(() => {
        useGameModalStore.setState({
            callAddressModal: () => {
                setActive(true)
            },
        })
        emitter.on("updateRollData", (data: any) => {
            setInputAddress(data || {})
            if (data?.name) {
                setFormDisabled(true)
            }
        })
        emitter.on("yostarLogout", (data: any) => {
            setInputAddress({
                name: "",
                phone: "",
                email: "",
                postcode: "",
                address: "",
            })
            setFormDisabled(false)
        })

    }, [])
    const [formDisabled, setFormDisabled] = useState<any>(false)
    const [inputAddress, setInputAddress] = useState<any>({})
    const address = useGameStore((state) => state.address)
    const rollResult = useGameStore((state) => state.rollResult)
    const handleInputName = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            // setName(trim(e.target.value).slice(0, 20))
            setInputAddress((prev: any) => ({
                ...prev,
                name: trim(e.target.value).slice(0, 20),
            }))
        },
        []
    )

    const handleInputPhone = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            // const value = e.target.value
            // if (!value || /^\d{0,16}$/.test(value)) {
            //     // setPhone(value.trim())
            //     setInputAddress((prev: any) => ({
            //         ...prev,
            //         phone: value.trim(),
            //     }))
            // }
            const cleanedValue = e.target.value.replace(/\D/g, "").slice(0, 16)
            setInputAddress((prev: any) => ({
                ...prev,
                phone: cleanedValue.trim(),
            }))
        },
        []
    )
    const handleInputEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setInputAddress((prev: any) => ({
            ...prev,
            email: trim(value).slice(0, 100),
        }))
    }
    const handleInputpostcode = (e: React.ChangeEvent<HTMLInputElement>) => {
        // const value = e.target.value
        // if (!value || /^\d{0,12}$/.test(value)) {
        //     setInputAddress((prev: any) => ({
        //         ...prev,
        //         postcode: value,
        //     }))
        // }
        const cleanedValue = e.target.value.replace(/\D/g, "").slice(0, 12)
        setInputAddress((prev: any) => ({
            ...prev,
            postcode: cleanedValue.trim(),
        }))
    }
    const handleChangeAddr = useCallback(
        (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            const value = e.target.value
            // setAddr(value.slice(0, 130))
            setInputAddress((prev: any) => ({
                ...prev,
                address: value.slice(0, 130),
            }))
        },
        []
    )
    const [loading, setLoading] = useState(false)

    const {
        state: { user },
    } = useContext(GlobalContext)
    const handleSubmit = useCallback(async () => {
        SFX.play("commonClick")
        console.log('inputAddress=========',inputAddress,address)
        if (
            loading ||
            address ||
            !inputAddress.name ||
            !inputAddress.phone ||
            !inputAddress.email ||
            !inputAddress.postcode ||
            !inputAddress.address
        ) {
            return
        }

        setLoading(true)

        const { code, msg } = await fill({
            name: inputAddress.name,
            phone: inputAddress.phone,
            email: inputAddress.email,
            postcode: inputAddress.postcode,
            address: inputAddress.address,
        })
        if (code === 0) {
            useGameStore.setState({ address: inputAddress })
            setFormDisabled(true)
            setLoading(false)
        } else {
            setLoading(false)
            Toast.message({ content: msg })
        }
    }, [address, inputAddress, loading])
    const handleClose = useCallback(() => {
        SFX.play("commonClick")
        if (loading) return
        setActive(false)
    }, [loading])

    return (
        <CSSTransition
            in={active}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                className={classNames(styles.addressModal, className)}
                style={style}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className={styles.doors}>
                    <div className={styles.leftDoor}></div>
                    <div className={styles.rightDoor}></div>
                </div>
                <div className={styles.maskBottom}></div>
                <ModalTitle className={styles.title}>
                    {i18n(i18nData, "rogue_4.game.title.roll.address")}
                </ModalTitle>
                <div className={styles.contentContainer}>
                    <div className={styles.awardNotice}>
                        {address
                            ? i18n(
                                  i18nData,
                                  "rogue_4.game.roll.award.confirm.line1"
                              )
                            : i18n(
                                  i18nData,
                                  "rogue_4.game.roll.award.line1"
                              ).replace(
                                  "$0",
                                  GAME_GIFT_DICT[rollResult.giftKey]?.name
                              )}
                    </div>
                    <div className={styles.awardNotice}>
                        {i18n(
                            i18nData,
                            address
                                ? "rogue_4.game.roll.award.confirm.line2"
                                : "rogue_4.game.roll.award.line2"
                        )}
                    </div>
                    <div className={styles.awardForm}>
                        <div className={styles.formItem}>
                            <div className={styles.label}>
                                {i18n(i18nData, "rogue_4.game.roll.form.name")}
                            </div>
                            <div className={styles.show}>
                                {/* <div className={styles.content}>
                                    {"asdasdasd"}
                                    {address?.name ?? inputAddress?.name ?? ""}
                                </div> */}
                                <input
                                    className={styles.nameInput}
                                    value={inputAddress.name}
                                    onChange={handleInputName}
                                    disabled={formDisabled}
                                    aria-label="full name"
                                />
                            </div>
                        </div>
                        <div className={styles.formItem}>
                            <div className={styles.label}>
                                {i18n(
                                    i18nData,
                                    "rogue_4.game.roll.form.telephone"
                                )}
                            </div>
                            <div className={styles.show}>
                                {/* <div className={styles.content}>
                                    {address?.phone ??
                                        inputAddress?.phone ??
                                        ""}
                                </div> */}
                                <input
                                    className={styles.phoneInput}
                                    value={inputAddress.phone}
                                    onChange={handleInputPhone}
                                    disabled={formDisabled}
                                    aria-label="phone"
                                />
                            </div>
                        </div>
                        <div className={styles.formItem}>
                            <div
                                className={classNames(
                                    styles.label,
                                    styles.emailLabel
                                )}
                            >
                                {i18n(i18nData, "rogue_4.game.roll.form.email")}
                            </div>
                            <div className={styles.show}>
                                {/* <div className={styles.content}>
                                    {address?.phone ??
                                        inputAddress?.phone ??
                                        ""}
                                </div> */}
                                <input
                                    className={styles.emailInput}
                                    value={inputAddress.email}
                                    onChange={handleInputEmail}
                                    disabled={formDisabled}
                                    aria-label="email"
                                />
                            </div>
                        </div>
                        <div className={styles.formItem}>
                            <div className={styles.label}>
                                {i18n(
                                    i18nData,
                                    "rogue_4.game.roll.form.postcode"
                                )}
                            </div>
                            <div className={styles.show}>
                                {/* <div className={styles.content}>
                                    {address?.phone ??
                                        inputAddress?.phone ??
                                        ""}
                                </div> */}
                                <input
                                    className={styles.postInput}
                                    value={inputAddress.postcode}
                                    onChange={handleInputpostcode}
                                    disabled={formDisabled}
                                    aria-label="postcode"
                                />
                            </div>
                        </div>
                        <div className={styles.formItem}>
                            <div className={styles.label}>
                                {i18n(
                                    i18nData,
                                    "rogue_4.game.roll.form.address"
                                )}
                            </div>
                            <div
                                className={classNames(styles.show, styles.area)}
                            >
                                {/* <Scroll
                                    direction="y"
                                    className={styles.content}
                                    rotateDetection
                                >
                                    {address?.address
                                        ? `${address.cityName[0]} ${address.cityName[1]} ${address.cityName[2]} ${address.address}`
                                        : inputAddress?.address
                                          ? `${inputAddress.cityName[0]} ${inputAddress.cityName[1]} ${inputAddress.cityName[2]} ${inputAddress.address}`
                                          : ""}
                                </Scroll> */}
                                <textarea
                                    className={styles.addrInput}
                                    value={inputAddress.address}
                                    onChange={handleChangeAddr}
                                    disabled={formDisabled}
                                    aria-label="addr"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className={classNames(
                            styles.afterConfirm,
                            !address && styles.active
                        )}
                    >
                        <span>
                            {i18n(i18nData, "rogue_4.game.roll.award.warn2")}
                        </span>
                    </div>
                    <div className={styles.buttonGroup}>
                        {address ? (
                            <Button
                                className={styles.button}
                                active={false}
                                size="small"
                                onClick={handleClose}
                            >
                                {i18n(i18nData, "rogue_4.game.roll.confirm")}
                            </Button>
                        ) : (
                            <>
                                {/* <Button
                                    className={styles.button}
                                    active={false}
                                    size="small"
                                    onClick={callSelectAddress}
                                >
                                    {i18n(
                                        i18nData,
                                        "rogue_4.game.roll.award.addressChange"
                                    )}
                                </Button> */}
                                <Button
                                    className={styles.button}
                                    active={false}
                                    size="small"
                                    onClick={handleSubmit}
                                >
                                    {i18n(i18nData, "rogue_4.game.roll.submit")}
                                </Button>
                            </>
                        )}
                    </div>
                </div>

                {/* <Button
                    active={false}
                    className={styles.backButton}
                    onClick={handleClose}
                    size="small"
                >
                    {i18n(i18nData, "rogue_4.game.roll.nextStep")}
                </Button> */}
            </div>
        </CSSTransition>
    )
}

export default AddressModal
